<template>
  <SidebarLayout2 :breadcrumb="breadcrumb" pageTitle="Regiões">
    <!-- SIDEBAR -->
    <template #sidebar>
      <Heading element="h2" class="sidebar-title">
        Ações da página
      </Heading>
      <div class="button">
        <!-- BOTÃO DE NOVO -->
        <Button
          v-if="selectedRows.length === 0"
          :hasIcon="true"
          class="button--create"
          @click="$router.push({ path: '/regioes/nova' })"
        >
          Inserir nova região
        </Button>
        <!-- BOTÃO DE EDIÇÃO - SÓ APARECE QUANDO ITENS SÃO SELECIONADOS-->
        <Button
          v-if="selectedRows.length === 1"
          :disabled="disabledButton"
          class="button--edit"
          @click="
            $router.push({ path: `/regioes/editar/${selectedRows[0].id}` })
          "
        >
          Editar
        </Button>
        <!-- BOTÃO DE EDIÇÃO FICA DESATIVADO QUANDO MAIS DE UMA LINHA ESTÁ SELECIONADA -->
        <div v-if="disabledButton">
          <Button :disabled="disabledButton" class="button--edit">
            Editar
          </Button>
        </div>
        <!-- BOTÃO DE DELEÇÃO - SÓ APARECE QUANDO LINHAS SÃO SELECIONADAS -->
        <Button
          v-if="selectedRows.length > 0"
          variation="error"
          class="button--delete"
          @click="showModal = true"
        >
          Desativar
        </Button>
      </div>
    </template>
    <template #content>
      <!-- BARRA DE BUSCA POR NOME -->
      <SearchInput v-model="filterByName" class="search-input" />
      <!-- LISTA DE REGIÕES -->
      <DataTable
        :cols="columns"
        :colsMinWidths="colsMinWidths"
        :isLoading="false"
        :rows="filterRegions"
        :selectableRow="true"
        ref="dataTable"
        class="datatable"
        @getSelectedRows="selectedRows = $event"
      >
        <template v-slot:actions="slotProps">
          <button
            class="action--item"
            @click.stop.prevent="
              $router.push({
                path: `/regioes/editar/${slotProps.rowDataObj.id}`
              })
            "
          >
            Editar
          </button>
        </template>
        <template v-slot:delete="slotProps">
          <button
            class="action--item__delete"
            @click.stop.prevent="deleteModal(slotProps.rowDataObj.id)"
          >
            Desativar
          </button>
        </template>
      </DataTable>
      <!-- MODAL DE DELEÇÃO -->
      <AlertModal
        v-model="showModal"
        :buttonClose="true"
        title="Você irá desativar essa região"
        class="delete-modal"
        @alert-modal-cancel="modalCancel"
        @alert-modal-confirm="deleteAction"
      >
        <template #text>
          Essa ação é irreversível. <br />
          Tem certeza que quer continuar?
        </template>
      </AlertModal>
    </template>
  </SidebarLayout2>
</template>

<script>
import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'
import Button from '@/components/_base/elements/Button'
import DataTable from '@solucoes/components-lib-tmp/src/components/patterns/DataTable'
import Heading from '@/components/_base/elements/Heading'
import SearchInput from '@/components/_base/elements/SearchInput'
import SidebarLayout2 from '@/layouts/SidebarLayout2.vue'

export default {
  name: 'RegionsList',
  components: {
    AlertModal,
    Button,
    DataTable,
    Heading,
    SearchInput,
    SidebarLayout2
    // SidebarBlock
  },
  data() {
    return {
      /** Breadcrumbs */
      breadcrumb: [
        {
          label: 'Configurações',
          url: ''
        },
        {
          label: 'Regiões',
          url: ''
        }
      ],
      colsMinWidths: { actions: '0px', delete: '0px' },
      /** Coluna da lista */
      columns: [
        {
          name: 'nome',
          alias: 'Nome da região'
        },
        {
          alias: 'Ações',
          name: 'actions'
        },
        {
          name: 'delete'
        }
      ],
      /** v-model do filtro por nome */
      filterByName: '',
      /** Array com os dados das regiões */
      regionsData: [],
      /** Array das linhas selecionadas */
      selectedRows: [],
      /** Linha selecionada */
      selectedRow: [],
      /** Estado da modal de deleção*/
      showModal: false
    }
  },
  computed: {
    disabledButton() {
      if (this.selectedRows.length > 1) {
        return true
      }
      return false
    },
    filterRegions() {
      return this.regionsData.filter(
        (data) =>
          data.data.nome
            .toLowerCase()
            .indexOf(this.filterByName.toLowerCase()) > -1
      )
    }
  },
  created() {
    this.getRegions()
  },
  methods: {
    getRegions() {
      this.$regions.getRegions().then((response) => {
        const data = response.data.sort((a, b) =>
          a.nome.toLowerCase() > b.nome.toLowerCase()
            ? 1
            : b.nome.toLowerCase() > a.nome.toLowerCase()
            ? -1
            : 0
        )
        this.regionsData = this.formatRegionsData(data)
      })
    },
    clearSelectedRows() {
      this.selectedRows = [] /** Limpar array de itens selecionados na tabela */
      this.selectedRow = null /** Limpar item selecionado na tabela */
      this.$refs.dataTable.selectAllRows()
    },
    deleteAction() {
      let regioes = null
      if (this.selectedRow === null || this.selectedRow.length === 0) {
        /** Se for 1 ou mais itens */
        regioes = this.selectedRows.map((item) => {
          return item.id.toFixed()
        })
      } else {
        /** Se for apenas 1 item */
        regioes = [this.selectedRow]
      }
      this.$regions
        .deleteRegion(regioes)
        .then(() => {
          /** Feedback de sucesso */
          this.$bus.$emit('show-alert-chip', {
            message: 'Região desativada'
          })
        })
        .catch(() => {
          /** Feedback de erro */
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao excluir o(s) grupo(s).'
          })
        })
        .finally(() => {
          /** Resetar tabela */
          this.getRegions()
          this.clearSelectedRows()
        })
    },
    deleteModal(id) {
      this.showModal = true
      if (id) {
        this.selectedRow = id
      }
    },
    formatRegionsData(data) {
      const array = []
      data.forEach((region) => {
        array.push({
          data: {
            id: region.codigo,
            nome: region.nome,
            hoteis: region.hoteis,
            status: region.ativo
          }
        })
      })
      return array
    },
    modalCancel() {
      this.showModal = false
      this.clearSelectedRows()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .no-gutters .col {
  padding-left: 15px;
}
.action {
  &--item {
    border: none;
    background-color: inherit;
    color: $primary;
    font-weight: font-weight('weight-medium');
    &__delete {
      border: none;
      background-color: inherit;
      color: $red-2;
      font-weight: font-weight('weight-medium');
    }
  }
}
::v-deep .content {
  .page-heading {
    padding-bottom: 24px;
  }
}
.sidebar-title {
  padding-top: 35px;
  margin-left: 20px;
  margin-bottom: 15px;
}
.button {
  width: 215px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: auto;
}

.datatable {
  ::v-deep {
    .pmw-td span {
      font-size: font-size('size-small');
    }
    .pmw-col.pmw-th:nth-child(3),
    .pmw-col.pmw-td:nth-child(3) {
      max-width: 75px;
    }
    .pmw-col.pmw-th:nth-child(3) {
      border-right: none;
    }
    .pmw-col.pmw-th:nth-child(4),
    .pmw-col.pmw-td:nth-child(4) {
      max-width: 90px;
    }
    .pmw-col.pmw-th:nth-child(3),
    .pmw-col.pmw-th:nth-child(4) {
      pointer-events: none;
      .pmw-sort-icons {
        display: none;
      }
    }
  }
  .action {
    &--item {
      font-size: font-size('size-small');
    }
  }
}
.search-input {
  width: 215px;
  margin-bottom: 38px;
}
::v-deep .thead .th {
  &:nth-last-child(2) {
    border-right: none;
  }
}
</style>
